(function () {
  'use strict';

  angular.module('app').component('measurementUnitsPage', measurementUnitListCtrl());

  function measurementUnitListCtrl() {
    return {
      bindings: {},
      controller: MeasurementUnitListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/measurement-units/measurement-units-page.component.html',
    };
  }

  MeasurementUnitListCtrl.$inject = [
    'UtilService',
    'AbilityService',
    'MeasurementUnitService',
    'LanguageService',
  ];

  function MeasurementUnitListCtrl(
    UtilService,
    AbilityService,
    MeasurementUnitService,
    LanguageService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_measurementunit_accountadmin'),
    };

    // Methods
    vm.createMeasurementUnit = createMeasurementUnit;
    vm.onShowMeasurementUnit = onShowMeasurementUnit;

    // Initializers
    getAdditionalLanguages();

    function getMeasurementUnits(selectedItem) {
      vm.filterCriteria = MeasurementUnitService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      MeasurementUnitService.getMeasurementUnits(vm.filterCriteria).then(function (data) {
        vm.measurementUnits = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        if (selectedItem) {
          vm.UtilService.itemListChanged(selectedItem.id);
        }
      });
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getMeasurementUnits('');
      });
    }

    function createMeasurementUnit() {
      if (!vm.permissions.canCreate) {
        return;
      }

      MeasurementUnitService.openMeasurementUnitModal(
        {},
        vm.defaultLanguage,
        vm.additionalLanguages,
        'create',
        getMeasurementUnits
      );
    }

    function onShowMeasurementUnit(measurementUnit, mode) {
      MeasurementUnitService.openMeasurementUnitModal(
        measurementUnit,
        vm.defaultLanguage,
        vm.additionalLanguages,
        mode
      );
    }
  }
})();
